import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'src/utils/Hooks';
import { RightArrow } from 'src/components/SvgIcons';

export const NoData = () => {
  const searchParams = useAppSelector((state) => state.app?.queryParams?.searchParams);
  const hashId = useAppSelector((state) => state.entityService.mainEntity?.hashId);

  return (
    <Link to={`/client/${hashId}${searchParams}&tab=advertising&subtab=rulesDetails`}>
      <Text
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        Create a new rule
        <RightArrow
          height={12}
          width={12}
          style={{
            marginLeft: '4px'
          }}
        />
      </Text>
    </Link>
  );
};
